import { render, staticRenderFns } from "./indexbk.vue?vue&type=template&id=35479fd4&scoped=true"
import script from "./indexbk.vue?vue&type=script&lang=js"
export * from "./indexbk.vue?vue&type=script&lang=js"
import style0 from "./indexbk.vue?vue&type=style&index=0&id=35479fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35479fd4",
  null
  
)

export default component.exports